import FileAjax from "./FileAjax";
const initFileAjax = (element) => {
    new FileAjax(element);
}

export {
    FileAjax,
    initFileAjax,
}
